import React, { useEffect, useState } from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Header from "./components/layout/Header";
import SingleProduct from "./pages/SingleProduct";
import Footer from "./components/layout/Footer";
import Services from "./pages/Services";
import SingleService from "./pages/SingleService";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Awards from "./pages/Awards";
import TopSvg from "./assets/icons/TopSvg";
import { useDispatch, useSelector } from 'react-redux';
import {  getContactData, getContent } from './services/actions/MainAction';
import Loader from './components/common/Loader';
import Lisences from './pages/Lisences';


function App() {
  const [topVisible, setTopVisible] = useState(false);
  const lang_id = useSelector(state=> state.Data.lang_id);
  const langPrefix = useSelector(state=> state.Data.langPrefix);
  const loader = useSelector(state=> state.Data.loader);
  const dispatch = useDispatch()
  useEffect(()=>{
    window.addEventListener("scroll", (e)=>{
      if(window.scrollY>=550){
        setTopVisible(true)
      }else{
        setTopVisible(false)
      }
    })
  },[]);

  useEffect(()=>{
    dispatch(getContent(lang_id));
    dispatch(getContactData(lang_id));
  },[lang_id])

  return (
   <BrowserRouter>
    <Header/>
    <Routes>
      <Route element={ <Home />} path={`/${langPrefix}`} />
      <Route element={ <Products />} path={`/${langPrefix}products`} />
      <Route element={ <SingleProduct />} path={`/${langPrefix}product/:id`} />
      <Route element={ <Services />} path={`/${langPrefix}services`} />
      <Route element={ <SingleService />} path={`/${langPrefix}service/:id`} />
      <Route element={ <Contact />} path={`/${langPrefix}contact`} />
      <Route element={ <About />} path={`/${langPrefix}about`} />
      <Route element={ <Awards />} path={`/${langPrefix}awards`} />
      <Route element={ <Lisences />} path={`/${langPrefix}license`} />
    </Routes>
    <Footer /> 
    {
      topVisible?
       <button onClick={()=>window.scrollTo(0,0)} className="fixed bottom-[50px] right-[20px] bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 w-[50px] h-[50px] rounded-full shadow flex items-center justify-center">
        <TopSvg />
      </button>:null
    }
   {loader? <Loader />:null}
   </BrowserRouter>
  );
}

export default App;
